import { UserDefinedItem } from "../../../types/domain";
import { faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { UserDefinedSortColumn } from "../../../types/domain";
import { DataTable, TableColumn, LinkCell, TextCell, ActionCell } from "@/components/common/Table";

export type UserDefinedListProps = {
  items: UserDefinedItem[],
  fetchItems: (sortColumn?: UserDefinedSortColumn, sortAsc?: boolean) => void,
  sortColumn: UserDefinedSortColumn,
  sortAsc: boolean,
  isLoading?: boolean,
  entityType: string
};

export const UserDefinedList = ({ items, fetchItems, sortColumn, sortAsc, isLoading = false, entityType }: UserDefinedListProps) => {
  const columns: TableColumn<UserDefinedItem, UserDefinedSortColumn>[] = [
    {
      key: "name",
      header: "Item",
      sortKey: UserDefinedSortColumn.Name,
      render: (item: UserDefinedItem) => (
        <LinkCell
          onClick={() => window.location.assign(`MaintenanceEntity.aspx?pageType=UserDefAdmin&pageAction=Edit&entityType=${entityType}&entityId=${item.id}`)}
          text={item.name}
        />
      )
    },
    {
      key: "categoryName",
      header: "Category",
      sortKey: UserDefinedSortColumn.CategoryName,
      render: (item: UserDefinedItem) => (
        <TextCell value={item.categoryName} />
      )
    },
    {
      key: "ownerName",
      header: "Owner",
      sortKey: UserDefinedSortColumn.OwnerName,
      render: (item: UserDefinedItem) => (
        <div className={!item.ownerEnabled ? "line-through" : ""}>
          <TextCell value={item.ownerName} />
        </div>
      )
    },
    {
      key: "lookup",
      header: "Lookup",
      sortKey: UserDefinedSortColumn.Lookup,
      skeleton: { variant: 'short' },
      render: (item: UserDefinedItem) => (
        <TextCell value={item.lookup ? "Lookup" : ""} />
      )
    },
    {
      key: "dataType",
      header: "Data Type",
      sortKey: UserDefinedSortColumn.DataType,
      render: (item: UserDefinedItem) => (
        <TextCell value={item.dataType} />
      )
    },
    {
      key: "subscriptions",
      header: "Subscriptions",
      sortKey: UserDefinedSortColumn.Subscriptions,
      render: (item: UserDefinedItem) => (
        <div className="text-gray-700 text-muted-foreground">
          {item.subCounts.userSubCount > 0 && (
            <div>Users: {item.subCounts.userSubCount}</div>
          )}
          {item.subCounts.groupSubCount > 0 && (
            <div>Groups: {item.subCounts.groupSubCount}</div>
          )}
          {item.subCounts.globalSubCount > 0 && (
            <div>Subscribed to Everyone</div>
          )}
          {item.subCounts.userCatSubCount > 0 && (
            <div>User Categories: {item.subCounts.userCatSubCount}</div>
          )}
          {item.subCounts.groupCatSubCount > 0 && (
            <div>Group Categories: {item.subCounts.groupCatSubCount}</div>
          )}
          {item.subCounts.globalCatSubCount > 0 && (
            <div>Category Subscribed to Everyone</div>
          )}
          {item.subCounts.userSubCount === 0 &&
            item.subCounts.groupSubCount === 0 &&
            item.subCounts.globalSubCount === 0 &&
            item.subCounts.userCatSubCount === 0 &&
            item.subCounts.groupCatSubCount === 0 &&
            item.subCounts.globalCatSubCount === 0 && (
              <div>No Subscriptions</div>
            )}
        </div>
      )
    },
    {
      key: "actions",
      header: "",
      isAction: true,
      skeleton: { variant: 'short' },
      render: (item: UserDefinedItem) => (
        <ActionCell
          actions={[
            {
              icon: faPencil,
              title: 'Edit',
              onClick: () => window.location.assign(`MaintenanceEntity.aspx?pageType=UserDefAdmin&pageAction=Edit&entityType=${entityType}&entityId=${item.id}`)
            },
            {
              icon: faTrashCan,
              title: 'Delete',
              onClick: () => window.location.assign(`MaintenanceEntity.aspx?pageType=UserDefAdmin&pageAction=Delete&entityType=${entityType}&entityId=${item.id}`)
            }
          ]}
        />
      )
    }
  ];

  return (
    <DataTable<UserDefinedItem, UserDefinedSortColumn>
      columns={columns}
      data={items}
      sortColumn={sortColumn}
      sortAsc={sortAsc}
      onSort={fetchItems}
      isLoading={isLoading}
      skeletonRows={10}
    />
  );
};
